import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useMarkersActions} from '../stores/selectors'

export type UpdateReviewCommentMutationResponse = {
  body: string
  bodyHTML: string
  bodyVersion: string
  commentDatabaseId: number
  threadId: number
}

/**
 * Updates the body of a review comment
 */
export function useUpdateReviewCommentMutation(basePath: string) {
  const apiUrl = `${basePath}/page_data/${PageData.updateReviewComment}`
  const {updateThreadComment} = useMarkersActions()

  return useMutation({
    mutationFn: async ({commentId, bodyVersion, body}: {commentId: string; bodyVersion?: string; body: string}) => {
      const response = await fetchWithErrorHandling(`${apiUrl}${bodyVersion ? `?body_version=${bodyVersion}` : ''}`, {
        method: 'PUT',
        body: {
          body,
          commentId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: UpdateReviewCommentMutationResponse) => {
      updateThreadComment({
        threadID: data.threadId,
        match: storedComment => storedComment.databaseId === data.commentDatabaseId,
        transform: oldComment => {
          if (oldComment) {
            return {
              ...oldComment,
              body: data.body,
              bodyHTML: data.bodyHTML,
              bodyVersion: data.bodyVersion,
            }
          }
        },
      })
    },
  })
}
